import React, { useEffect } from 'react';
import { Switch } from 'react-router';
import { Home } from './components/Home';
import { useHistory } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { message } from "antd";
import Login from "./components/Login";
import Category from "./components/Category";
import Products from "./components/Products";

import UsrContext from "./context/UsrContext";

import Layout from "./components/Layout";
import LayoutedRoute from './components/LayoutedRoute';
import LoginLayout from "./components/LoginLayout";

import { setAuthorization, deleteAuthorization } from "./services/httpService";
import { login } from './services/authService';


function App() {
  const [user, setUser] = React.useState(undefined);
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("token");
    
    if(!token) return; 
    
    // Sets user
    setUser(jwt_decode(token));

    // Sets authorization header brearer token
    setAuthorization(token);
  }, []);

  // Login
  const handleLogin = async (username, password) => {
    let response;

    try {
        response = await login(username, password);
    } catch (error) {
        message.warning("Invalid user name or password");
        return;
    }

    const token = response.data.token;
    
    // Sets authorization header brearer token
    setAuthorization(token);
    
    // Set LocalStorage
    localStorage.setItem("token", token);

    const user = jwt_decode(token);
    setUser(user);
    history.push('/home');
  };

  // Logout
  const handleLogout = () => {
    // Elimina token de local storage
    localStorage.removeItem("token");

    // Remove Authorization header
    deleteAuthorization();

    setUser(undefined);

    // Return to Home
    history.push('/');
  };

  return (
    <UsrContext.Provider value={{ user: user, onLoggedIn: handleLogin, onLogOut: handleLogout }}>
      <Switch>
        <LayoutedRoute path="/home" layout={Layout} component={Home} />
        <LayoutedRoute path="/productos/categorias" layout={Layout} component={Category} />
        <LayoutedRoute path="/productos/productos" layout={Layout} component={Products} />
        <LayoutedRoute path="/" layout={LoginLayout} component={Login} />
      </Switch>
    </UsrContext.Provider>
  );
  
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx